import type { Lawyer, PublicCase } from "./types";

export const lawyers: Lawyer[] = [
  {
    id: "chen-bo-fu",
    name: "陳柏甫",
    barNo: "103臺檢證字第11820號",
    officeName: "陳柏甫律師事務所",
    guild: "台北律師公會",
    status: "active",
    location: "台北市大安區",
    sourceUpdatedAt: "2026-05-28",
    summary:
      "公開裁判書示範資料顯示，其刑事辯護紀錄橫跨毒品、詐欺洗錢、組織犯罪、銀行法、家暴傷害與交通過失等案由。",
    practiceTags: ["刑事辯護", "毒品", "詐欺洗錢", "法扶案件", "上訴程序"],
    riskFlags: ["示範資料僅含公開裁判書片段，非完整委任紀錄"],
    dataNotice: "本 profile 由公開資料與本產品示範資料集組成，正式上線需接完整資料管線。",
  },
  {
    id: "lin-pin-an-demo",
    name: "林品安（示範）",
    officeName: "衡策法律事務所（示範）",
    guild: "台北律師公會",
    status: "active",
    location: "台北市中正區",
    sourceUpdatedAt: "2026-05-30",
    summary:
      "示範律師 profile：公開案件樣本集中於詐欺、洗錢與金融犯罪，適合測試候選律師比較流程。",
    practiceTags: ["詐欺洗錢", "金融犯罪", "二審上訴", "羈押抗告"],
    riskFlags: ["示範資料，非真實律師"],
    dataNotice: "Demo only.",
  },
  {
    id: "wang-cheng-yue-demo",
    name: "王承岳（示範）",
    officeName: "承岳法律事務所（示範）",
    guild: "新北律師公會",
    status: "active",
    location: "新北市板橋區",
    sourceUpdatedAt: "2026-05-30",
    summary:
      "示範律師 profile：樣本集中在家暴傷害、跟蹤騷擾、交通過失與和解型案件。",
    practiceTags: ["傷害", "家暴", "交通事故", "緩刑策略"],
    riskFlags: ["示範資料，非真實律師"],
    dataNotice: "Demo only.",
  },
  {
    id: "chang-yi-rou-demo",
    name: "張以柔（示範）",
    officeName: "瀚證法律事務所（示範）",
    guild: "桃園律師公會",
    status: "active",
    location: "桃園市桃園區",
    sourceUpdatedAt: "2026-05-30",
    summary:
      "示範律師 profile：樣本集中於毒品、槍砲與重大刑案，適合測試高風險刑事案件分析。",
    practiceTags: ["毒品", "槍砲", "重大刑案", "最高法院"],
    riskFlags: ["示範資料，非真實律師"],
    dataNotice: "Demo only.",
  },
];

export const publicCases: PublicCase[] = [
  {
    id: "TPSM-114-taishang-899-20260422",
    lawyerId: "chen-bo-fu",
    court: "最高法院",
    caseNo: "114年度台上字第899號",
    date: "2026-04-22",
    cause: "違反組織犯罪防制條例等罪",
    category: "fraud_money_laundering",
    stage: "supreme_court",
    role: "選任辯護人",
    representedParty: "邱陳佑竑",
    legalAid: false,
    outcomeTags: ["撤銷發回", "部分上訴駁回", "第三審"],
    outcomeSummary: "原判決關於陳永謙犯發起犯罪組織及邱陳佑竑部分撤銷，發回臺灣高等法院；其他上訴駁回。",
    resultQuality: "strong",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=TPSM%2c114%2c%e5%8f%b0%e4%b8%8a%2c899%2c20260422%2c1&ot=in",
    evidenceText: "上訴人邱陳佑竑選任辯護人陳柏甫律師。",
  },
  {
    id: "PCDM-114-yuansu-5-20260415",
    lawyerId: "chen-bo-fu",
    court: "臺灣新北地方法院",
    caseNo: "114年度原訴字第5號",
    date: "2026-04-15",
    cause: "殺人未遂等",
    category: "weapons",
    stage: "first_instance",
    role: "法扶辯護人",
    representedParty: "李宗航",
    legalAid: true,
    outcomeTags: ["宣判期日變更", "程序裁定"],
    outcomeSummary: "裁定變更宣判期日，尚非實體判決。",
    resultQuality: "unknown",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=PCDM%2c114%2c%e5%8e%9f%e8%a8%b4%2c5%2c20260415%2c1&ot=in",
    evidenceText: "被告李宗航選任辯護人陳柏甫法扶律師。",
  },
  {
    id: "TPDM-113-jinzhongsu-39-20260317",
    lawyerId: "chen-bo-fu",
    court: "臺灣臺北地方法院",
    caseNo: "113年度金重訴字第39號",
    date: "2026-03-17",
    cause: "銀行法等",
    category: "financial_banking",
    stage: "first_instance",
    role: "法扶辯護人",
    representedParty: "張登勝",
    legalAid: true,
    outcomeTags: ["延長限制出境", "程序裁定"],
    outcomeSummary: "裁定延長限制出境、出海八月。",
    resultQuality: "limited",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=TPDM%2c113%2c%e9%87%91%e9%87%8d%e8%a8%b4%2c39%2c20260317%2c3&ot=in",
    evidenceText: "被告張登勝選任辯護人陳柏甫律師（法扶律師）。",
  },
  {
    id: "PCDM-114-shenyi-4050-20260211",
    lawyerId: "chen-bo-fu",
    court: "臺灣新北地方法院",
    caseNo: "114年度審易字第4050號",
    date: "2026-02-11",
    cause: "跟蹤騷擾防制法",
    category: "violence_family",
    stage: "first_instance",
    role: "選任辯護人",
    representedParty: "黃柏霖",
    legalAid: false,
    outcomeTags: ["拘役", "緩刑"],
    outcomeSummary: "跟蹤騷擾罪，處拘役四十日，緩刑二年。",
    resultQuality: "strong",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=PCDM%2c114%2c%e5%af%a9%e6%98%93%2c4050%2c20260211%2c1&ot=in",
    evidenceText: "被告黃柏霖選任辯護人陳柏甫律師。",
  },
  {
    id: "TPDM-114-yi-800-20260106",
    lawyerId: "chen-bo-fu",
    court: "臺灣臺北地方法院",
    caseNo: "114年度易字第800號",
    date: "2026-01-06",
    cause: "家庭暴力罪之傷害",
    category: "violence_family",
    stage: "first_instance",
    role: "選任辯護人",
    representedParty: "王鐿臻",
    legalAid: false,
    outcomeTags: ["拘役", "易科罰金"],
    outcomeSummary: "傷害罪，處拘役四十五日，如易科罰金以新臺幣一千元折算一日。",
    resultQuality: "mixed",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=TPDM%2c114%2c%e6%98%93%2c800%2c20260106%2c1&ot=in",
    evidenceText: "被告王鐿臻選任辯護人陳柏甫律師。",
  },
  {
    id: "PCDM-114-jiaosuzhui-2-20250827",
    lawyerId: "chen-bo-fu",
    court: "臺灣新北地方法院",
    caseNo: "114年度交訴緝字第2號",
    date: "2025-08-27",
    cause: "過失致死",
    category: "traffic_negligence",
    stage: "first_instance",
    role: "法扶辯護人",
    representedParty: "王延平",
    legalAid: true,
    outcomeTags: ["有期徒刑", "法扶"],
    outcomeSummary: "過失致死罪，處有期徒刑十月。",
    resultQuality: "limited",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=PCDM%2c114%2c%e4%ba%a4%e8%a8%b4%e7%b7%9d%2c2%2c20250827%2c1&ot=in",
    evidenceText: "被告王延平選任辯護人陳柏甫律師（法扶律師）。",
  },
  {
    id: "TPDM-113-su-730-20241127",
    lawyerId: "chen-bo-fu",
    court: "臺灣臺北地方法院",
    caseNo: "113年度訴字第730號",
    date: "2024-11-27",
    cause: "毒品危害防制條例",
    category: "drug",
    stage: "first_instance",
    role: "選任辯護人",
    representedParty: "高正文",
    legalAid: false,
    outcomeTags: ["應執行刑", "沒收"],
    outcomeSummary: "多罪各處刑，應執行有期徒刑三年四月。",
    resultQuality: "limited",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=TPDM%2c113%2c%e8%a8%b4%2c730%2c20241127%2c1&ot=in",
    evidenceText: "被告高正文選任辯護人陳柏甫律師。",
  },
  {
    id: "TPSM-112-taishang-3537-20230921",
    lawyerId: "chen-bo-fu",
    court: "最高法院",
    caseNo: "112年度台上字第3537號",
    date: "2023-09-21",
    cause: "妨害性自主",
    category: "sexual_offense",
    stage: "supreme_court",
    role: "選任辯護人",
    representedParty: "朱國平",
    legalAid: false,
    outcomeTags: ["上訴駁回", "第三審"],
    outcomeSummary: "最高法院判決上訴駁回。",
    resultQuality: "limited",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=TPSM%2c112%2c%e5%8f%b0%e4%b8%8a%2c3537%2c20230921%2c1&ot=in",
    evidenceText: "上訴人朱國平選任辯護人陳柏甫律師。",
  },
  {
    id: "TPHM-110-shangsu-1486-20220518",
    lawyerId: "chen-bo-fu",
    court: "臺灣高等法院",
    caseNo: "110年度上訴字第1486號",
    date: "2022-05-18",
    cause: "違反槍砲彈藥刀械管制條例",
    category: "weapons",
    stage: "appeal",
    role: "法扶辯護人",
    representedParty: "陳明煌",
    legalAid: true,
    outcomeTags: ["上訴駁回", "法扶"],
    outcomeSummary: "二審判決上訴駁回。",
    resultQuality: "limited",
    sourceUrl:
      "https://judgment.judicial.gov.tw/FJUD/data.aspx?ty=JD&id=TPHM%2c110%2c%e4%b8%8a%e8%a8%b4%2c1486%2c20220518%2c2&ot=in",
    evidenceText: "上訴人即被告陳明煌選任辯護人陳柏甫律師（法扶律師）。",
  },
  {
    id: "demo-lin-fraud-001",
    lawyerId: "lin-pin-an-demo",
    court: "臺灣臺北地方法院",
    caseNo: "示範金訴字第101號",
    date: "2026-03-05",
    cause: "洗錢防制法等",
    category: "fraud_money_laundering",
    stage: "first_instance",
    role: "選任辯護人",
    representedParty: "示範被告A",
    legalAid: false,
    outcomeTags: ["緩刑", "簡式審判"],
    outcomeSummary: "示範資料：認罪後爭取緩刑。",
    resultQuality: "strong",
    sourceUrl: "demo://judgment/lin-fraud-001",
    evidenceText: "示範資料，非真實裁判書。",
  },
  {
    id: "demo-lin-finance-002",
    lawyerId: "lin-pin-an-demo",
    court: "臺灣臺北地方法院",
    caseNo: "示範金重訴字第202號",
    date: "2025-11-18",
    cause: "銀行法等",
    category: "financial_banking",
    stage: "detention",
    role: "選任辯護人",
    representedParty: "示範被告B",
    legalAid: false,
    outcomeTags: ["具保停止羈押", "限制出境"],
    outcomeSummary: "示範資料：羈押程序中爭取具保。",
    resultQuality: "strong",
    sourceUrl: "demo://judgment/lin-finance-002",
    evidenceText: "示範資料，非真實裁判書。",
  },
  {
    id: "demo-wang-violence-001",
    lawyerId: "wang-cheng-yue-demo",
    court: "臺灣新北地方法院",
    caseNo: "示範易字第301號",
    date: "2026-01-20",
    cause: "家庭暴力罪之傷害",
    category: "violence_family",
    stage: "first_instance",
    role: "選任辯護人",
    representedParty: "示範被告C",
    legalAid: false,
    outcomeTags: ["拘役", "緩刑", "保護令"],
    outcomeSummary: "示範資料：量刑集中在緩刑與修復條件。",
    resultQuality: "strong",
    sourceUrl: "demo://judgment/wang-violence-001",
    evidenceText: "示範資料，非真實裁判書。",
  },
  {
    id: "demo-wang-traffic-002",
    lawyerId: "wang-cheng-yue-demo",
    court: "臺灣新北地方法院",
    caseNo: "示範交訴字第302號",
    date: "2025-08-12",
    cause: "過失致死",
    category: "traffic_negligence",
    stage: "first_instance",
    role: "選任辯護人",
    representedParty: "示範被告D",
    legalAid: false,
    outcomeTags: ["和解", "緩刑"],
    outcomeSummary: "示範資料：以和解與賠償作為量刑重點。",
    resultQuality: "strong",
    sourceUrl: "demo://judgment/wang-traffic-002",
    evidenceText: "示範資料，非真實裁判書。",
  },
  {
    id: "demo-chang-drug-001",
    lawyerId: "chang-yi-rou-demo",
    court: "臺灣桃園地方法院",
    caseNo: "示範訴字第401號",
    date: "2026-02-02",
    cause: "毒品危害防制條例",
    category: "drug",
    stage: "first_instance",
    role: "選任辯護人",
    representedParty: "示範被告E",
    legalAid: false,
    outcomeTags: ["減刑", "供出來源"],
    outcomeSummary: "示範資料：爭取毒品條例減刑與量刑下降。",
    resultQuality: "strong",
    sourceUrl: "demo://judgment/chang-drug-001",
    evidenceText: "示範資料，非真實裁判書。",
  },
  {
    id: "demo-chang-weapons-002",
    lawyerId: "chang-yi-rou-demo",
    court: "臺灣高等法院",
    caseNo: "示範上訴字第402號",
    date: "2025-06-22",
    cause: "違反槍砲彈藥刀械管制條例",
    category: "weapons",
    stage: "appeal",
    role: "選任辯護人",
    representedParty: "示範被告F",
    legalAid: false,
    outcomeTags: ["撤銷改判", "量刑下降"],
    outcomeSummary: "示範資料：二審撤銷改判並降低量刑。",
    resultQuality: "strong",
    sourceUrl: "demo://judgment/chang-weapons-002",
    evidenceText: "示範資料，非真實裁判書。",
  },
];
